import { type SupabaseClient } from "@supabase/supabase-js";

import { type Database } from "@fitness-app/supabase";

import { normalizeCustomClaims } from "./normalizeCustomClaims";

export const getLoggedUser = async (auth: SupabaseClient<Database>["auth"]) => {
  const { data, error } = await auth.getSession();

  if (!data?.session || error) {
    // Try to refresh the session before throwing an error
    const { data: refreshData, error: refreshError } = await auth.refreshSession();

    if (!refreshData?.session || refreshError) {
      throw new Error("user-is-not-logged");
    }

    return {
      id: refreshData.session.user.id,
      email: refreshData.session.user.email || "",
      isAdmin: false,
      customClaims: normalizeCustomClaims(refreshData.session.user.app_metadata),
    };
  }

  return {
    id: data.session.user.id,
    email: data.session.user.email || "",
    isAdmin: false,
    customClaims: normalizeCustomClaims(data.session.user.app_metadata),
  };
};
